import tableDataReducer from "./tableData"
import checkBoxReducer from "./checkBox"
import pageSize from "./pageSize"

import { combineReducers } from 'redux';

const allReducers = combineReducers({
    Data: tableDataReducer,
    CheckBoxCount: checkBoxReducer,
    pgSize: pageSize,
});

export default allReducers;